import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "@/components/ui/dialog";
import { InterestForm } from "@/components/forms/InterestForm";

const TITLES = {
  join: "Join CT BLAZERS",
  tryout: "AAU Tryout Interest",
  clinic: "Summer Clinic Registration",
  "3v3": "Winter 3v3 Registration",
};

export function InterestDialog({ category, program, children, testId }) {
  const [open, setOpen] = useState(false);
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="bg-ink-800 border-white/10 text-white max-w-xl max-h-[90vh] overflow-y-auto" data-testid={testId ? `${testId}-dialog` : "interest-dialog"}>
        <DialogHeader>
          <DialogTitle className="font-heading text-3xl tracking-wide text-white">
            {TITLES[category] || program}
          </DialogTitle>
          <DialogDescription className="text-white/60">
            Share your details and we'll reach out with dates, details and registration info.
          </DialogDescription>
        </DialogHeader>
        <InterestForm category={category} program={program} onDone={() => setOpen(false)} className="mt-2" />
      </DialogContent>
    </Dialog>
  );
}
